module.exports = __webpack_public_path__ + "img/jsonpath-help1.4d3bcf02.png";